module.exports = __webpack_public_path__ + "resources/img/img_coolfilter4_m.460c92de28aaabab277cd1c5a7409afe.png";